import React from 'react';
import { InputNumber } from 'antd';
import {
  createDisabledDateForRanges,
  createDateRangeField
} from '../../utils/dateRangeFieldUtils';

export const useFields = ({
  subscriptionPrices,
  purpose,
  subscriptionPriceToEdit
}) => {
  const disabledDate = createDisabledDateForRanges(
    subscriptionPrices,
    purpose,
    subscriptionPriceToEdit
  );

  const fields = [
    createDateRangeField(['application_date'], disabledDate),
    createDateRangeField(['end_date'], disabledDate),
    {
      name: ['price'],
      rules: [{ required: true }],
      input: <InputNumber addonAfter="€" />
    }
  ];

  return { fields };
};
